import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import useWidth from '../utils/useWidth';

const useStyles = makeStyles(theme => ({
  breakpoint: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: theme.spacing(),
    zIndex: 9999,
    ...theme.typography.caption,
  },
}));

const Breakpoint = () => {
  const width = useWidth();
  const classes = useStyles();
  return (
    process.env.NODE_ENV !== 'production' && (
      <div className={classes.breakpoint}>{width}</div>
    )
  );
};

export default Breakpoint;
